// extracted by mini-css-extract-plugin
module.exports = {"host":"disclaimer_host__MXc_g","text":"disclaimer_text__O4YpJ"};